<template>
  <div class="w-100 px-4">
    <div class="w-100 d-flex flex-column flex-fill justify-content-center">
      <h1>{{firstData(dataList).titleH1}}</h1>
      <p class="text-left">{{firstData(dataList).contentP}}</p>
      <div class="d-flex justify-content-center">
        <a class="btn btn-sm btn-outline-primary"
          :href="firstData(dataList).buttonUrl">{{firstData(dataList).buttonName}}</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: {
      dataList: {
        type: Array
      }
    },
    methods: {
      firstData(list) {
        return _.first(list, (item, key) => {
          return (item.delete == false);
        });
      }

    }
  };

</script>
